import { THEM_CHANGE } from "../constants/themeConstants";

export const themeChangeReducer = (state = { theme: "light" }, action) => {
  switch (action.type) {
    case THEM_CHANGE:
      return { ...state, theme: action.payload };
    default:
      return state;
  }
};
